module.exports = __webpack_public_path__ + "img/loginBg.7d66a6fa.svg";